(function () {
  function getConnection() {
    return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  }

  function shouldSkipVideo() {
    var connection = getConnection();

    if (connection && connection.saveData) return true;

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return true;
    }

    return false;
  }

  function replaceHeadingIcons() {
    document.querySelectorAll('[data-cb-design-cta]').forEach(function (section) {
      if (section.dataset.cbHeadingIconsReady === 'true') return;

      var iconOneTemplate = section.querySelector('[data-icon-one-template]');
      var iconTwoTemplate = section.querySelector('[data-icon-two-template]');

      var starIcon = iconOneTemplate ? iconOneTemplate.innerHTML.trim() : '';
      var ringIcon = iconTwoTemplate ? iconTwoTemplate.innerHTML.trim() : '';

      if (!starIcon && !ringIcon) return;

      section.querySelectorAll('.cb-design-cta__display-heading').forEach(function (heading) {
        var html = heading.innerHTML;

        if (starIcon) {
          html = html.replace(/\{star\}/gi, '<span class="cb-design-cta__inline-icon cb-design-cta__inline-icon--star" aria-hidden="true">' + starIcon + '</span>');
        }

        if (ringIcon) {
          html = html.replace(/\{ring\}/gi, '<span class="cb-design-cta__inline-icon cb-design-cta__inline-icon--ring" aria-hidden="true">' + ringIcon + '</span>');
        }

        heading.innerHTML = html;
      });

      section.dataset.cbHeadingIconsReady = 'true';
    });
  }

  function initVideo(video) {
    if (!video || video.dataset.cbVideoReady === 'true') return;

    video.dataset.cbVideoReady = 'true';

    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.preload = 'metadata';

    video.addEventListener(
      'loadeddata',
      function () {
        video.classList.add('is-ready');
      },
      { once: true }
    );

    var playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (!video || video.paused) return;
    video.pause();
  }

  function bootVideos() {
    var videos = Array.prototype.slice.call(
      document.querySelectorAll('[data-cb-design-lazy-video]')
    );

    if (!videos.length || shouldSkipVideo()) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(initVideo);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            initVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      {
        root: null,
        rootMargin: '180px 0px',
        threshold: 0.18
      }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function boot() {
    replaceHeadingIcons();
    bootVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();